import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [ReactiveFormsModule, NgClass, NzButtonModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputComponent {
  @Input() label: string = '';
  @Input() type: 'text' | 'password' = 'text';
  @Input() control: AbstractControl = new FormControl();
  @Input() prefix: 'person' | 'lock-closed' | 'search';
  @Input() postfix: 'eye';

  public get formControl(): FormControl {
    return this.control as FormControl;
  }

  public onPostfixClick(): void {
    switch (this.postfix) {
      case 'eye': {
        this.type = this.type === 'text' ? 'password' : 'text';
        break;
      }
    }
  }
}
